export default {
  methods: {
    setMapClearButtonSelected() {
      if (this.featureUnlocked("map-events-ai-clear-button")) {
        const element = document.getElementById("map-clear-all-button");
        if (element) {
          element.title = "Clear Map Icons";
          element.classList.replace("hyp-clear-button", "hyp-selected-button");
        }
      }
    },
  },
};
